import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CustomizerMenuPartModel } from '@models/customizer-menu-part';

@Component({
	selector: 'customizer-component-header2',
	templateUrl: 'customizer-component-header2.html',
	styleUrls: ['./customizer-component-header2.scss'],
	imports: [CommonModule, TranslatePipe]
})
export class CustomizerComponentHeader2Component {

	@Input() menu: CustomizerMenuPartModel;
	@Input() overrideTranslateName: string;
	@Input() className: string;
	@Input() showTranslateDecription?: boolean = true;

	@Output() updateCollapsedOnComponent: EventEmitter<boolean> = new EventEmitter();

	get parentOrMenu(): CustomizerMenuPartModel {
		return this.menu.parentMenu || this.menu;
	}

}
